import FilloutEmbed from './FilloutEmbed';

const spaces = [
  {
    title: 'Courtyard',
    description: 'An outdoor ceremony setting framed by the estate’s Spanish Revival architecture.',
    image: 'https://ik.imagekit.io/aeu02xvjgn/09-padua-hills-claremont-wedding-photography.jpg',
    alt: 'Courtyard wedding setting at Padua Hills Theatre',
  },
  {
    title: 'Terrace',
    description: 'An open-air terrace for gathering and taking in the Claremont foothills.',
    image: 'https://ik.imagekit.io/aeu02xvjgn/Padua-Hills-Weddings-Michelle-and-Joshua-922.jpg',
    alt: 'Terrace at Padua Hills Theatre',
  },
  {
    title: 'Indoor ballroom',
    description: 'An indoor ballroom setting for the reception.',
    image: 'https://ik.imagekit.io/aeu02xvjgn/26-padua-hills-theatre-claremont-persian-wedding-photography.jpg',
    alt: 'Indoor ballroom at Padua Hills Theatre',
  },
];

function getOptimizedImageUrl(url, width) {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}tr=w-${width},q-85,f-auto`;
}

function getResponsiveImageSources(url) {
  return [
    `${getOptimizedImageUrl(url, 480)} 480w`,
    `${getOptimizedImageUrl(url, 720)} 720w`,
    `${getOptimizedImageUrl(url, 960)} 960w`,
  ].join(', ');
}

export function CampaignEstate() {
  return (
    <section id="campaign-estate" className="bg-[#F6F1E8] px-6 py-20 sm:py-24">
      <div className="mx-auto max-w-6xl">
        <div className="mb-10 max-w-2xl">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.24em] text-[#6E7451]">The estate</p>
          <h2 className="font-serif text-3xl font-light leading-tight text-[#2F2B28] sm:text-4xl">Three settings, one connected celebration</h2>
        </div>
        <div className="grid gap-6 md:grid-cols-3">
          {spaces.map((space) => (
            <article key={space.title} className="overflow-hidden border border-[#D9CCBA] bg-[#FCFAF6]">
              <div className="aspect-[4/3] overflow-hidden bg-[#D9CCBA]">
                <img
                  src={getOptimizedImageUrl(space.image, 960)}
                  srcSet={getResponsiveImageSources(space.image)}
                  sizes="(min-width: 768px) 33vw, (min-width: 640px) 50vw, 100vw"
                  alt={space.alt}
                  width="1200"
                  height="900"
                  loading="lazy"
                  decoding="async"
                  className="h-full w-full object-cover"
                />
              </div>
              <div className="p-5 sm:p-6">
                <h3 className="font-serif text-2xl text-[#2F2B28]">{space.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#2F2B28]/80">{space.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CampaignInvestment() {
  return (
    <section id="campaign-investment" className="bg-[#FCFAF6] px-6 py-20 sm:py-24">
      <div className="mx-auto grid max-w-6xl gap-8 md:grid-cols-[0.8fr_1.2fr] md:items-start">
        <div>
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.24em] text-[#6E7451]">Investment guidance</p>
          <h2 className="font-serif text-3xl font-light leading-tight text-[#2F2B28] sm:text-4xl">Published minimums</h2>
        </div>
        <div className="border-l border-[#D9CCBA] pl-5 text-sm leading-7 text-[#2F2B28]/85 sm:pl-7">
          <p>
            Published catering, venue and rental minimums excluding alcohol are $16,000 weekdays, $23,000 Fridays, $31,000 Saturdays and holidays, and $20,000 Sundays.
          </p>
          <p className="mt-4">
            A 22% administrative fee or 25% for outdoor dining, applicable tax and additional items apply.
          </p>
        </div>
      </div>
    </section>
  );
}

export function CampaignInquiry() {
  return (
    <section id="campaign-inquiry" className="scroll-mt-6 bg-[#2F2B28] px-5 py-16 text-[#FCFAF6] sm:px-6 sm:py-20">
      <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-14">
        <div>
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.24em] text-[#D9CCBA]">Date and tour inquiry</p>
          <h2 className="font-serif text-3xl font-light sm:text-4xl">Check your date with our team</h2>
          <p className="mt-5 max-w-lg text-sm leading-7 text-[#FCFAF6]/80">
            Share a few details in the inquiry form. Our team will confirm date availability and discuss tour arrangements.
          </p>
          <div className="mt-8 space-y-2 text-sm text-[#FCFAF6]/90">
            <p><a className="underline underline-offset-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4" href="tel:9096248628">(909)624-8628</a></p>
            <p>4467 Padua Ave, Claremont CA 91711</p>
            <p><a className="underline underline-offset-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4" href="/privacy-policy">Privacy policy</a></p>
          </div>
        </div>
        <div className="min-w-0 bg-[#FCFAF6] p-3 text-[#2F2B28] sm:p-5">
          <FilloutEmbed />
        </div>
      </div>
    </section>
  );
}